import { createIcons } from 'lucide/dist/umd/lucide'

createIcons({})
